import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import { endPoints } from "../../../config";
import { axiosInstnace } from "../../../util/util";

const VerifyMobile = (props) => {
  const closePopup = () => {
    props.hide();
  };
  const [code, setCode] = useState("");
  const [verifycode, setverfifycode] = useState("");
  const [randomcode, setrandomcode] = useState("");
  useEffect(() => {
    sendCode();
  }, []);

  const sendCode = () => {
    let randomcodefour = Math.floor(1000 + Math.random() * 9000);
    setrandomcode(randomcodefour);
    axiosInstnace.get(endPoints.sendotp, {
      params: {
        randomcode: randomcodefour,
        mobile: props.mobile,
      },
    });
  };
  const verifyCode = () => {
    if (parseInt(code) === randomcode) {
      // alert('Verified Successfully')
      props.verify();
    } else {
      alert("Please enter the valid Code");
    }
  };
  //Return the popup for approve request
  return props.isShowing ? (
    <div>
      <div className="modal-overlay">
        <div
          className="modal-wrapper thankyou-popup"
          aria-modal
          aria-hidden
          tabIndex={-1}
          role="dialog"
        >
          <div className="modal approval">
            <div className="modal-head-cross rate-modal">
              <button
                type="button"
                className="modal-close-button"
                onClick={closePopup}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="editNonFct-header modal-header">
                <h4 className="popup-head rqst-head fct-head modal-title">
                  Verify Your Mobile Number
                </h4>
              </div>
              <div className="approval-content modal-body">
                <div className="popup-container reqst-rejection">
                  <p className="reqst-para approval-reqst">
                    {"Enter 4 digit code we sent to "}{props.mobile}
                  </p>
                  <div style={{ marginBottom: "25px" }}>
                    <input
                      type="number"
                      name="code"
                      value={code}
                      className="packageType"
                      onChange={(e) => {
                        setCode(e.target.value);
                      }}
                      placeholder="Verification Code"
                    ></input>
                    <span>
                      <a
                        style={{
                          marginLeft: "5%",
                          color: "blue",
                          fontSize: "13px",
                          cursor: "pointer",
                        }}
                        onClick={sendCode}
                      >
                        Resend Code
                      </a>
                    </span>
                  </div>
                  <div className="confirn-btn">
                    <button className="cancel-reqst" onClick={props.hide}>
                      CANCEL
                    </button>
                    <button className="confirm-reqst" onClick={verifyCode}>
                      VERIFY
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default VerifyMobile;



// WEBPACK FOOTER //
// ./web/components/salesUser/campaign/verifymobilejs.js